import React from 'react';

import { AboutUs, Chef, FindUs, Footer, Gallery, Header, Intro, Laurels, SpecialMenu } from './container';
import { Navbar } from './components';
import './App.css';
import ChefSecond from './container/Chef_second/Chef_second';
// import Head from 'next/head';

const App = () => (
  <div>
    {/* <Head> */}
    {/* <meta charset="utf-8" />
      <title>Prakruti Organics</title>
      <meta name="description" content="Best Organic Hair Oil Brand in India" />
      <meta property="og:type" content="Health Website" />
      <meta property="og:title" content="Prakruti Organics" />
      <meta property="og:description" content="Best Organic Hair Oil Brand in India" />
      <meta property="og:site_name" content="Prakruti Organics" />
      <meta property="twitter:card" content="summary" />
      <meta property="twitter:creator" content="Prakruti Organics" />
      <meta property="twitter:title" content="Prakruti Organics" />
      <meta property="twitter:description" content="Best Organic Hair Oil Brand in India" />
     */}
    {/* </Head> */}
    <Navbar />
    <Header />
    <AboutUs />
    <SpecialMenu />
    <Chef />
    <ChefSecond/>
    <Intro />
    <Laurels />
    <Gallery />
    <FindUs />
    <Footer /> 
  </div>
);

export default App;
